import { SparePart } from '@ecs-features/result/spare-parts-result/spare-parts.interface';

/**
 * All availability codes which are displayed for normal users.
 */
const displayedAvailabilityCodes: string[] = ['00', '04', '03', '07'];

/**
 * Filter a part with a availability code, which should not be displayed.
 * Configurable through {@link #displayedAvailabilityCodes}.
 *
 * @param sparePart spare part to be filtered
 * @returns true, if the spart part is displayed, else false
 */
export const displayPartByAvailabilityCodeFilter = (sparePart: SparePart): boolean =>
    displayedAvailabilityCodes.includes(sparePart.availabilityCode);
